import styled from 'styled-components';
import NeverBeforeSvg from '../../../assets/onboarding/newHome/never-before.svg';

const NeverBeforeIcon = styled(NeverBeforeSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.4rem'};
height: ${props => props.height || '4.4rem'};
display: flex;
`;

export default NeverBeforeIcon;
